import { Box, Typography } from '@mui/material';
import React from 'react';

import { translate } from '@/ui/i18n';

export function Contact() {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window?.hbspt) {
        window.hbspt.forms.create({
          portalId: '145008169',
          formId: 'ac68acca-20ad-4a65-a1e8-d43c0f5f4e04',
          target: '#hubspotForm',
        });
      }
    });
  }, []);
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        {translate('Contact.title')}
      </Typography>

      <Box
        sx={{
          padding: '15px',
        }}
      >
        <div id="hubspotForm"></div>
      </Box>
    </Box>
  );
}
